<template>
	<div class="DownLoadTop">
		<div class="left-menu">
			<template v-for="(item,index) in TopList">
				<div class="menu-item" :title="item.NodeName" :class="[FileType===item.NodeID?'current':'']"
					@click="handShow(item)">
					<span class="text">{{item.NodeName}}</span>
					<img src="../../../../assets/channel/menu/menuDown.png" :class="[item.Show ? 's-hide':'s-show' ]">
				</div>
				<div class="menu-child" v-if="item.Show" :title="item1.NodeName"
					:class="[FileType===item1.NodeID?'current':'']" v-for="(item1,inde1x) in item.Nodes"
					@click="handClick(item1)">
					{{item1.NodeName}}
				</div>
			</template>
		</div>
		<div class="right-view">
			<DataDownLoadTop @searchClick="searchClick" :modelValue="title" ref="DownRef"
				v-show="DownLoadArr.length > 0"></DataDownLoadTop>
			<DataDownLoadList :DownLoadArr="DownLoadArr" @handleSizeChange="handleSizeChange"
				@handleCurrentChange="handleCurrentChange" :pageSize="pageSize" :total="total"></DataDownLoadList>
		</div>
	</div>
</template>

<script>
	import DataDownLoadTop from './components/DataDownLoadTop.vue'
	import DataDownLoadList from './components/DataDownLoadList.vue'
	import {
		DataDownloadListApi,
		DataDownloadClassListForNode
	} from '@/api/channel'
	export default {
		components: {
			DataDownLoadTop,
			DataDownLoadList
		},
		data() {
			return {
				FileType: '',
				TopList: [],
				change: 0,
				DownLoadArr: [],
				total: 0,
				pageSize: 12,
				pageindex: 1,
				title: '',
				Creator: '',
				createTime1: '',
				createTime2: '',
				modelValue: ''
			}
		},
		created() {
			this.DataDownloadListApi()
			this.getHelperDataDownloadType();
		},
		mounted() {

		},
		methods: {
			// 下载文件列表
			async DataDownloadListApi() {

				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await DataDownloadListApi({
					FileType: this.FileType,
					Creator: this.Creator,
					title: this.title,
					createTime1: this.createTime1,
					createTime2: this.createTime2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.DownLoadArr = data.data.map(item => {
						item.Show = true;
						return item;
					})
					this.total = data.Count
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			//获取文件类型
			async getHelperDataDownloadType() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassListForNode({})
				if (code == 0) {
					this.TopList = data;
				} else {
					this.$message.warning(message)
				}
			},
			searchClick(val) {
				console.log('val');
				this.title = val
				this.Creator = this.$refs.DownRef.FromArr[0].modelvalue
				this.createTime1 = this.$refs.DownRef.FromArr[1].StartTime
				this.createTime2 = this.$refs.DownRef.FromArr[1].EndTime
				console.log(this.$refs.DownRef.FromArr[1].StartTime, 'DownRef');
				this.DataDownloadListApi()
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.DataDownloadListApi()
			},
			handleSizeChange(pagesize) {
				this.pageSize = this.pageSize
				this.DataDownloadListApi()
			},
			handClick(e) {
				this.FileType = e.NodeID;
				this.DataDownloadListApi();
			},
			handShow(e) {
				e.Show = !e.Show;
				this.$forceUpdate();
			}
		},
		watch: {
			$route: {
				handler(newRouter, oldRouter) {
					console.log(newRouter.query.FileName, '----newRouter');
					if (newRouter.query.title) {
						this.title = newRouter.query.title
						this.DataDownloadListApi()
					}
				},
				immediate: true,
				deep: true
			}
		}
	}
</script>

<style lang="less" scoped>
	.DownLoadTop {
		min-height: 650px;
		padding-top: 20px;
		width: 1200px;
		margin: 16px auto;
		display: flex;
	}

	.left-menu {
		min-width: 240px;
		max-width: 240px;
		height: 520px;
		background: #FFFFFF;
		border-radius: 6px 6px 6px 6px;
		padding: 6px;
		overflow: auto;

		.menu-item {
			height: 40px;
			line-height: 40px;
			background: #FFFFFF;
			padding-left: 16px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.text {
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 600;
				color: #333333;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.s-show {
				width: 18px;
				height: 18px;
			}

			.s-hide {
				width: 18px;
				height: 18px;
				transform: rotate(180deg);
			}
		}

		.menu-child {
			height: 40px;
			line-height: 40px;
			background: #FFFFFF;
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
			padding-left: 38px;
			cursor: pointer;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

		}

		.current {
			background: #F0F2F5;
			border-right: 2px solid #183B7B;
		}
	}

	.right-view {
		padding-left: 22px;
		flex: 1;
	}

	.warningTop {
		height: 64px;
		background-color: #ffffff;
		position: relative;
		user-select: none;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		border: 1px solid #eaecef;
		display: flex;
		justify-content: center;

		.TopState {
			display: inline-block;
			line-height: 64px;
			margin-left: 32px;
			font-size: 14px;
			font-weight: 500;
			color: #9ca5b8;
			position: relative;
			cursor: pointer;

			div {
				display: inline-block;
				height: 15px;
				width: 1px;
				background-color: #cfd6e6;
				margin-left: 16px;
				position: relative;
				top: 2px;
			}
		}
	}
</style>
